<div class="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4" (click)="cancel()">
  <div
    class="w-full max-w-md rounded-2xl bg-white p-6 shadow-xl"
    role="dialog"
    aria-modal="true"
    [attr.aria-labelledby]="titleId"
    (click)="$event.stopPropagation()"
  >
    <h3 [id]="titleId" class="mb-3 text-xl font-bold text-gray-900">
      <ng-content select="[dialogTitle]" />
    </h3>
    <p class="mb-6 text-gray-600">
      <ng-content />
    </p>
    @if (error(); as message) {
      <p class="-mt-3 mb-6 text-sm text-red-600">{{ message }}</p>
    }
    <div class="flex justify-end gap-3">
      <button
        type="button"
        class="rounded-lg px-4 py-2 font-semibold text-gray-700 transition-colors hover:bg-gray-100 disabled:opacity-50"
        [disabled]="busy()"
        (click)="cancel()"
      >
        {{ cancelLabel() }}
      </button>
      <button
        type="button"
        class="rounded-lg bg-red-600 px-4 py-2 font-semibold text-white transition-colors hover:bg-red-700 disabled:opacity-50"
        [disabled]="busy()"
        (click)="confirm()"
      >
        {{ busy() ? busyLabel() : confirmLabel() }}
      </button>
    </div>
  </div>
</div>
